module.exports = __webpack_public_path__ + "img/logo-footer.4a60302b.png";